import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Mail, Loader2, ArrowLeft, Check } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch {
      // Still show success to avoid leaking which emails exist
      setDone(true);
    } finally { setLoading(false); }
  };

  return (
    <div className="container-x py-20 md:py-28 min-h-[70vh] flex items-center" data-testid="forgot-password-page">
      <div className="grid md:grid-cols-2 gap-16 w-full items-center">
        <div className="hidden md:block">
          <div className="overline mb-4">Account recovery</div>
          <h1 className="font-serif text-5xl tracking-tight text-[#111]">Forgot your <span className="gold-shimmer-text">password?</span></h1>
          <p className="mt-5 text-[#4A554E]">Enter the email on your ShoNics account and we'll send a secure reset link. Links expire in 30 minutes.</p>
        </div>
        <form onSubmit={submit} className="card-luxe p-8 md:p-10 max-w-md w-full mx-auto" data-testid="forgot-form">
          <div className="flex items-center gap-2 mb-6">
            <Mail className="w-5 h-5 text-[#D4AF37]" />
            <h2 className="font-serif text-2xl">Reset your password</h2>
          </div>
          {done ? (
            <div className="text-center py-6" data-testid="forgot-success">
              <div className="w-14 h-14 rounded-full bg-[#0B5D3B]/10 flex items-center justify-center mx-auto mb-4">
                <Check className="w-7 h-7 text-[#0B5D3B]" />
              </div>
              <h3 className="font-serif text-xl mb-2">Check your inbox</h3>
              <p className="text-sm text-[#4A554E]">If an account exists for <span className="font-semibold">{email}</span>, a password reset link has been generated. It expires in 30 minutes.</p>
              <Link to="/login" className="btn-primary mt-6 text-sm py-2.5 px-5">Back to sign in</Link>
            </div>
          ) : (
            <>
              <label className="overline">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full px-5 py-3.5 mt-2 mb-7 rounded-full border border-[#EAE3D2] focus:border-[#0B5D3B] focus:outline-none"
                placeholder="you@example.com"
                data-testid="forgot-email" />
              <button disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="forgot-submit">
                {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Sending…</> : "Send reset link"}
              </button>
              <Link to="/login" className="mt-5 inline-flex items-center gap-1 text-sm text-[#7A8A81] hover:text-[#111]">
                <ArrowLeft className="w-3 h-3" /> Back to sign in
              </Link>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
